export default __webpack_public_path__ + "static/media/icone-meus-conteudos-linha.b7e6667c.svg";